<template>
  <div :class="{
    'round-checkbox-wrapper': true,
    'round-checkbox-wrapper-readonly': readonly 
  }">
    <div :class="toggleClass" @click="toggle"></div>
    <h3
      :class="{
        'round-checkbox-label': true,
        'round-checkbox-label-selected': value,
      }"
    >
      <slot></slot>
    </h3>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
    readonly: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    toggle() {
      if (!this.readonly) this.$emit("input", !this.value);
    },
  },
  computed: {
    toggleClass() {
      return {
        "round-checkbox-toggle": true,
        "round-checkbox-toggle-active": !!this.value
      };
    },
  },
};
</script>

<style scoped>
.round-checkbox-wrapper {
  display: flex;
  align-items: center;
}

.round-checkbox-wrapper:first-child {
  margin-top: 0;
}

.round-checkbox-toggle {
  height: 2.5vh;
  width: 2.5vh;
  border-radius: 0.5vh;
  border: 1px solid #908f8d;
  /* background: #A4A3A1; */
  cursor: pointer;
  margin-right: 1.5vh;
}

.round-checkbox-toggle-active {
  background: #129b81;
  border: 1px solid #129b81;
}

.round-checkbox-label {
  padding-right: 2vh;
  width: 95%;
  font-size: 2.3vh;
  line-height: 2.5vh;
  margin-bottom: 0;

  color: #a4a3a1;
}

.round-checkbox-label-selected {
  color: #ededed;
}

.round-checkbox-wrapper-readonly {
  opacity: 0.7;
}
</style>
